import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {PartnerSummaryModel} from '../../../../partner/common/api/model/partnerSummary.model';
import {Moment} from 'moment-timezone';
import {AccountingAccountModel} from '../../../account/api/entity/accountingAccount.model';
import {Payload} from '../../../../core/service/payload/payload';
import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {AccountingMovementSummaryModel} from './accountingMovementSummary.model';

export class AccountingMovementModel extends WithSummaryModel<AccountingMovementSummaryModel>{
    comment: string;
    communication: string;
    targetAccount: AccountingAccountModel;
    sourceAccount: AccountingAccountModel;
    label: LovValueSummary;
    partner: PartnerSummaryModel;
}

export enum MovementType {
    EXPENDITURE = 'EXPENDITURE',
    REVENUE = 'REVENUE',
    TRANSFER = 'TRANSFER',
}

export enum PaymentType {
    CHECK = 'CHECK',
    CASH = 'CASH',
    BANK = 'BANK',
    CARD = 'CARD',
    ONLINE = 'ONLINE',
}

export class MovementCreating {
    id: number;
    comment: string;
    date: Moment;
    amount: number;
    typeValue: string;
    paymentTypeValue: string;
    targetAccountId: number;
    sourceAccountId: number;
    labelValue: number;
    partnerId: number;

    check: AccountingMovementCheckPayload;
}

export class AccountingMovementCheckPayload implements Payload {
    number: string;
    from: string;
    bankValue: string;
}
